var render = function (_h,_vm) {var _c=_vm._c;return _c('section',{class:['vf-announce-layout', _vm.data.staticClass, _vm.data.class]},[_vm._t("header"),_c('div',{class:[
            'vf-x-tight-vertical-margin-gap',
            {
                'vf-x-tight-margin-top':
                    _vm.props.size === _vm.injections.SIZES.SMALL,
                'vf-x-loose-margin-top':
                    _vm.props.size === _vm.injections.SIZES.LARGE
            }
        ]},[(_vm.props.title)?_c('h2',{staticClass:"vf-announce-layout__title vf-subheading-text"},[_vm._v(" "+_vm._s(_vm.props.title)+" ")]):_vm._e(),(_vm.props.subtitle)?_c('p',{staticClass:"vf-announce-layout__subtitle vf-primary-text"},[_vm._v(" "+_vm._s(_vm.props.subtitle)+" ")]):_vm._e()]),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }